import React, { useState } from 'react'
import '../choose-purifier-service/choose-for-purifier.scss'
import NormalInput from '../../common/inputs/NormalInput'
import { useSearchParams } from 'react-router-dom'

function FilterAllocation({ setModal }) {
    const [searchParams, setSearchParams] = useSearchParams()

    const [form, setForm] = useState({
        from_date: searchParams.get('from_date') || '',
        end_date: searchParams.get('end_date') || '',
        bill_no: searchParams.get('bill_no') || '',
        receipt_no: searchParams.get('receipt_no') || '',
        transaction_id: searchParams.get('transaction_id') || ''
    })

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        setSearchParams((prev) => {
            const next = new URLSearchParams(prev);
            if (form?.from_date) {
                next.set('from_date', form?.from_date);
            } else {
                next.delete('from_date')
            }

            if (form?.end_date) {
                next.set('end_date', form?.end_date);
            } else {
                next.delete('end_date')
            }

            if (form?.bill_no) {
                next.set('bill_no', form?.bill_no);
            } else {
                next.delete('bill_no')
            }

            if (form?.receipt_no) {
                next.set('receipt_no', form?.receipt_no);
            } else {
                next.delete('receipt_no')
            }

            if (form?.transaction_id) {
                next.set('transaction_id', form?.transaction_id);
            } else {
                next.delete('transaction_id')
            }
            return next;
        })

        setModal({ status: false })
    }

    return (
        <div className='choose-for-purifier-div'>
            <form action="" onSubmit={handleSubmit}>
                <NormalInput label='Bill No' name='bill_no' value={form?.bill_no || ''} onChangeFun={handleChange} isRequired={false}
                    placeholder={'Enter Bill No'} />
                <NormalInput label='Receipt No' name='receipt_no' value={form?.receipt_no || ''} onChangeFun={handleChange} isRequired={false}
                    placeholder={'Enter Receipt No'} />
                <NormalInput label='Transaction Id' name='transaction_id' value={form?.transaction_id || ''} onChangeFun={handleChange} isRequired={false}
                    placeholder={'Enter Transaction Id'} />
                <NormalInput label='From date' type={'date'} name='from_date' value={form?.from_date || ''} onChangeFun={handleChange}
                    min={'2022-10-11'} max={form?.end_date} isRequired={false} />
                <NormalInput label='End date' type={'date'} name='end_date' value={form?.end_date || ''} onChangeFun={handleChange}
                    min={'2022-10-11'} max={new Date().toISOString().split('T')[0]} isRequired={false} />
                <div className="button-div">
                    <button type='submit'>Filter</button>
                </div>
            </form>
        </div>
    )
}

export default FilterAllocation